import { RequestParam } from "../../domain/models/RequestParam";
import { applog } from '../../domain/utils/applog';

export function urlBuild(basePath: string, params: RequestParam[]): string {

    const amount = params.filter(n => n.name === 'amount')[0];
    const sku = params.filter(n => n.name === 'sku')[0];
    console.log('🔶 [urlBuild] amount param:', amount, '| sku param:', sku);
    if(amount.subprod !== 0) {
        sku.value = `${sku.value}|${amount.subprod}`;
    }

    let endpoint = basePath;
    let first = true;
    params.forEach(element => {
        if (first) {
            first = false;
        } else {
            endpoint += '&';
        }
        endpoint += `${element.name}=${element.value}`
    });
    console.log('🔶 [urlBuild] URL final:', endpoint);
    applog('urlBuild',"Endpoint", endpoint);
    return endpoint;

}